import { createEntityAdapter } from '@ngrx/entity';
import { UserEntityState } from '@get/api-interfaces';
import { CustomEntityState } from '@get/store/configs/states';

export type IState = CustomEntityState<UserEntityState>;

export const adapter = createEntityAdapter<UserEntityState>({
  selectId: o => o.idUser
});
export const initialState: IState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const userFeatureKey = 'user';
